import { COMMA, ENTER } from "@angular/cdk/keycodes"
import { Timestamp } from "@angular/fire/firestore"
import { nanoid } from "nanoid"

export const AUTO_COMPLETE_LIMIT = 100
export const separatorKeysCodes = [ENTER, COMMA]

export const PackageIds = {
  nbcefifdjadcaddmglilehcjfbndbgjl: "Dev Super Streaming / Good Good Golf",
  ipacackgkiokinnjfmbpggbofhfciele: "Prod Super Streaming",
  accgfhkgbmmnbenibhmalomcggggfmad: "Prod Good Good Golf"
} as Record<string, string>

export function timeGroupBits(timestamp?: Timestamp) {
  const date = timestamp?.toDate() || new Date()

  return [date, date?.toTimeString().slice(0, 5)]
}

export function stopProp(event: Event) {
  event.stopPropagation()

  return true
}

export enum AuctionStates {
  active = "Active",
  pending = "Pending",
  running = "Running",
  finished = "Finished",
  all = "All"
}

export function LogForm(
  target: unknown,
  key: string,
  descriptor: PropertyDescriptor
) {
  const originalMethod = descriptor.value

  descriptor.value = function (...args: unknown[]) {
    const result = originalMethod.apply(this, args)
    console.log(target, key, result.value)
    return result
  }

  return descriptor
}

export function StopProp(
  _target: unknown,
  _key: string,
  descriptor: PropertyDescriptor
) {
  const originalMethod = descriptor.value

  descriptor.value = function (...args: unknown[]) {
    const event = args[0] as Event
    event.stopPropagation()
    const result = originalMethod.apply(this, args)
    return result
  }

  return descriptor
}

export function makeHash(len: number) {
  return nanoid(len)
}

export function toTitleCase(str: string) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word: any) => {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(" ")
}

export function toSelectOptions(items: string[]) {
  return items.map((item) => ({
    value: item,
    name: toTitleCase(item)
  }))
}

export type ShopifyProduct = {
  id: string
  collectionId: string
  title: string
  imgUrl: string
}

export const iconSVGPaths = {
  trivia:
    "M4.20158 0.0023387C3.5546 0.0351983 2.93954 0.408789 2.63631 1.00341L2.08566 2.08186L1.00778 2.6328C0.195564 3.04752 -0.189154 3.97869 0.0915816 4.84595L0.464153 5.99824L0.0915816 7.1517C-0.189754 8.01896 0.194393 8.94953 1.00661 9.36485L2.08449 9.91462L2.63631 10.9931C3.04122 11.7865 4.00313 12.1858 4.84714 11.9109L6 11.537L7.15169 11.9097C7.33585 11.9698 7.52677 12 7.71992 12C8.41696 12 9.04636 11.6142 9.36369 10.9931L9.91434 9.91462L10.9934 9.36368C11.805 8.94836 12.1898 8.01718 11.9084 7.15053L11.5358 5.99824L11.9084 4.84595C12.1898 3.97809 11.8056 3.04752 10.9934 2.6328L9.91551 2.08186L9.36369 1.00341C8.95938 0.210581 7.99747 -0.187542 7.15286 0.0867385L6 0.459504L4.84831 0.0879107C4.63581 0.0187403 4.41724 -0.00861452 4.20158 0.0023387ZM4.24962 1.198C4.32543 1.19432 4.40337 1.20342 4.47925 1.22848L5.81489 1.66103C5.93546 1.70004 6.06571 1.70004 6.18629 1.66103L7.52309 1.22731C7.81942 1.13008 8.15421 1.27121 8.29518 1.5485L8.93488 2.80043C8.99247 2.91266 9.0828 3.00421 9.19497 3.06183L10.4474 3.70186C10.7312 3.8471 10.8656 4.17301 10.7673 4.4767L10.3349 5.81303C10.296 5.93306 10.296 6.06224 10.3349 6.18228L10.3947 6.36749L10.7673 7.51978C10.8656 7.82347 10.7318 8.14937 10.4474 8.29462L9.19497 8.93465C9.0828 8.99226 8.99247 9.08265 8.93488 9.19488L8.29518 10.4468C8.15421 10.7235 7.82425 10.867 7.52192 10.768L6.18511 10.3354C6.12513 10.3156 6.06239 10.3061 6 10.3061C5.93761 10.3061 5.87487 10.315 5.81489 10.3354L4.47808 10.7692C4.18055 10.8664 3.84579 10.7247 3.70482 10.448L3.06629 9.19605C3.00871 9.08382 2.9172 8.99226 2.80503 8.93465L1.55375 8.29462C1.27001 8.14937 1.13435 7.82347 1.23273 7.51978L1.66505 6.18345C1.70404 6.06341 1.70404 5.93424 1.66505 5.8142L1.23273 4.4767C1.13435 4.17301 1.26941 3.8471 1.55375 3.70186L2.80503 3.06183C2.9166 3.00421 3.00814 2.91383 3.06512 2.8016L3.70482 1.54967C3.8101 1.34171 4.02219 1.20906 4.24962 1.198ZM6 2.99736C4.83147 2.99736 4.20041 3.92523 4.20041 4.79789H5.40014C5.40014 4.73607 5.41693 4.19771 6 4.19771C6.55667 4.19771 6.59986 4.65744 6.59986 4.79789C6.59986 5.13699 6.41197 5.37104 6.10544 5.72394C5.79112 6.08525 5.40014 6.5342 5.40014 7.19859H6.59986C6.59986 6.99393 6.75616 6.80338 7.0111 6.5105C7.34402 6.12759 7.79959 5.60392 7.79959 4.79789C7.79959 3.90302 7.18173 2.99736 6 2.99736ZM5.40014 7.79877V8.99912H6.59986V7.79877H5.40014Z",
  recall:
    "M5.5 0V1.50502H6.5V0H5.5ZM2.11133 1.40899L1.4043 2.11839L2.46484 3.18248L3.17188 2.47309L2.11133 1.40899ZM9.88867 1.40899L8.82812 2.47309L9.53516 3.18248L10.5957 2.11839L9.88867 1.40899ZM6 2.50836C4.07283 2.50836 2.5 4.08645 2.5 6.02007C2.5 7.40859 3.32806 8.57972 4.5 9.14768V10.5351C4.5 11.0835 4.95347 11.5385 5.5 11.5385H6.5C7.04653 11.5385 7.5 11.0835 7.5 10.5351V9.14768C8.67194 8.57972 9.5 7.40859 9.5 6.02007C9.5 4.08645 7.92717 2.50836 6 2.50836ZM6 3.51171C7.38683 3.51171 8.5 4.6286 8.5 6.02007C8.5 7.11589 7.80267 8.03822 6.83301 8.38243L6.5 8.50001V10.5351H5.5V8.50001L5.16699 8.38243C4.19733 8.03822 3.5 7.11589 3.5 6.02007C3.5 4.6286 4.61317 3.51171 6 3.51171ZM0 5.51839V6.52174H1.5V5.51839H0ZM10.5 5.51839V6.52174H12V5.51839H10.5ZM2.46484 8.85765L1.4043 9.92175L2.11133 10.6311L3.17188 9.56705L2.46484 8.85765ZM9.53516 8.85765L8.82812 9.56705L9.88867 10.6311L10.5957 9.92175L9.53516 8.85765Z",
  predict:
    "M6.6 0C6.20994 0 5.87362 0.146069 5.54404 0.291113C4.52803 -0.179687 3.29138 -0.0300474 2.45566 0.805664C2.27926 0.982068 2.14247 1.17736 2.03457 1.38359L2.01846 1.375C1.68465 1.95289 1.59893 2.60294 1.70586 3.21621C0.70152 3.78005 0 4.81947 0 6.05C0 7.0509 0.487567 7.91342 1.19131 8.51641C1.45248 9.91768 2.64962 11 4.125 11C4.63217 11 5.07902 10.8042 5.5 10.5821C5.92098 10.8042 6.36783 11 6.875 11C8.35038 11 9.54752 9.91768 9.80869 8.51641C10.5124 7.91342 11 7.0509 11 6.05C11 4.81917 10.2983 3.77831 9.29414 3.21406C9.31561 3.09039 9.33365 2.96721 9.33818 2.84131C9.34182 2.8107 9.35 2.78244 9.35 2.75C9.35 2.63643 9.341 2.52491 9.32744 2.41484C9.3267 2.40868 9.325 2.40274 9.32422 2.39658C9.30829 2.27411 9.27638 2.158 9.24473 2.04102C9.21391 1.92504 9.18416 1.80912 9.13731 1.69619C9.13451 1.6895 9.13264 1.68244 9.12979 1.67578C9.08648 1.57371 9.03834 1.47333 8.98154 1.375L8.96973 1.38252C8.49258 0.561324 7.61294 0 6.6 0ZM6.6 1.1C7.23826 1.1 7.78066 1.45852 8.05557 1.98301C8.08958 2.04743 8.11881 2.11314 8.14365 2.17959C8.16083 2.22658 8.17582 2.27459 8.18877 2.32354C8.20236 2.3734 8.21332 2.42362 8.22207 2.47393C8.23348 2.54241 8.24072 2.61221 8.24356 2.6834C8.24502 2.71753 8.24745 2.75143 8.24678 2.78545C8.24469 2.86522 8.23844 2.94455 8.22314 3.02393C8.22296 3.02503 8.22226 3.02604 8.22207 3.02715C8.20452 3.11724 8.17936 3.20758 8.14688 3.29893L8.08242 3.48154C7.94285 3.76325 7.72026 4.00832 7.425 4.17871L7.975 5.13154C8.36914 4.90409 8.6748 4.58585 8.9042 4.2249C9.50132 4.61584 9.9 5.27941 9.9 6.05C9.9 6.77991 9.54353 7.41534 8.99551 7.81816L8.80322 7.95996L8.77529 8.19736C8.6627 9.15872 7.86698 9.9 6.875 9.9C6.57819 9.9 6.2998 9.83336 6.05 9.71416V7.94277C6.37377 8.13231 6.74499 8.24952 7.14463 8.25L7.1457 7.15C6.53356 7.14926 6.04926 6.66358 6.05 6.05107V1.21279C6.22486 1.1471 6.40579 1.1 6.6 1.1ZM4.45908 1.10537C4.62541 1.11266 4.79091 1.1468 4.95 1.2042V4.40107H4.94678C4.94752 5.01358 4.46319 5.49926 3.85107 5.5L3.85215 6.6C4.25316 6.59951 4.62548 6.48136 4.95 6.29063V9.71416C4.7002 9.83336 4.42182 9.9 4.125 9.9C3.13302 9.9 2.3373 9.15872 2.22471 8.19736L2.19678 7.95996L2.00449 7.81816C1.45647 7.41534 1.1 6.77991 1.1 6.05C1.1 5.27935 1.49855 4.61614 2.0958 4.2249C2.3252 4.58585 2.63086 4.90409 3.025 5.13154L3.575 4.17871C3.27732 4.00692 3.05263 3.75863 2.91328 3.47402L2.85205 3.3C2.75445 3.02406 2.73345 2.72939 2.78437 2.446C2.79216 2.40544 2.80029 2.36486 2.81123 2.32461C2.82209 2.28282 2.83244 2.24099 2.84668 2.2C2.8782 2.11213 2.91628 2.02538 2.96377 1.94111C3.03533 1.81367 3.12426 1.69254 3.2334 1.5834C3.57331 1.24349 4.01835 1.08606 4.45908 1.10537Z"
}

export const shopifyApps: Record<string, string> = {
  "1ee3bb688103a8c3a8a13b6f748bb91f": "seaders' app",
  c97a5634e445bf4c8868d20ea0255401: "tiago's app",
  "18cab8a9a925926c39deb785f6eb5fb9": "dev-superstreaming",
  a189c9d66b4141fc04b0eb3c810270c1: "staging-superstreaming",
  a35a72de30c99ffd08edb831a07a7732: "prod-superstreaming"
}
